<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="exportPdf"
                    v-can="'Reports.Export'"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="exportExcel"
                    v-can="'Reports.Export'"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              class=""
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header border-0 pb-0">
              <div
                class="d-flex flex-wrap justify-content-between align-items-center row-gap-3"
              >
                <div class="d-flex align-items-center">
                  <span class="me-2"
                    ><i class="ti ti-chart-line text-danger"></i
                  ></span>
                  <h5>Attendance</h5>
                </div>
                <div class="dropdown">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {{ yearLabel }}
                  </a>
                  <ul class="dropdown-menu dropdown-menu-end p-2">
                    <li v-for="y in yearOptions" :key="y">
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item rounded-1"
                        @click.prevent="setYear(y)"
                      >
                        {{ y }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="card-body py-0 px-2">
              <div id="attendance-report">
                <apexchart
                  type="line"
                  height="200"
                  :options="attendanceChart.options"
                  :series="attendanceChart.series"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Employee Attendance</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3 dq-list-toolbar"
          >
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input
                  type="text"
                  class="form-control date-range bookingrange"
                  ref="dateRangeInput"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                />
                <span class="input-icon-addon">
                  <i class="ti ti-chevron-down"></i>
                </span>
              </div>
            </div>
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ statusLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatusFilter('')"
                  >
                    All Statuses
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatusFilter('Present')"
                  >
                    Present
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatusFilter('Late')"
                  >
                    Late
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatusFilter('Uninformed')"
                  >
                    Uninformed
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatusFilter('Permission')"
                  >
                    Permission
                  </a>
                </li>
              </ul>
            </div>

            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Range : {{ rangeLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setQuickRange('last7')"
                  >
                    Last 7 Days
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setQuickRange('last30')"
                  >
                    Last 30 Days
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setQuickRange('thisMonth')"
                  >
                    This Month
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setQuickRange('lastMonth')"
                  >
                    Last Month
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <attendance-report-table
              :rows="store.attendanceRows"
              :loading="store.attendanceLoading"
              :total="store.attendanceTotal"
              :page-size="store.attendancePageSize"
              :current="store.attendanceCurrent"
              @change="onTableChange"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->
</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import { ref, reactive, computed, onMounted } from "vue";

import { useAttendanceEmployeeStore } from "@/stores/attendanceEmployeeStore";
import AttendanceReportTable from "./attendance-report-table.vue";

const title = "Attendance Report";
const text = "HR";
const text1 = "Attendance Report";

const store = useAttendanceEmployeeStore();

const dateRangeInput = ref(null);

const currentYear = moment().year();
const yearLabel = ref("This Year");

const yearOptions = computed(() => [
  currentYear,
  currentYear - 1,
  currentYear - 2,
]);

// Filters for the report (date range + status + pagination)
const filters = reactive({
  from: moment().subtract(6, "days").format("YYYY-MM-DD"),
  to: moment().format("YYYY-MM-DD"),
  status: "",
  page: 1,
  per_page: 25,
});

const rangeLabel = ref("Last 7 Days");
const statusLabel = computed(() =>
  filters.status ? filters.status : "All Statuses"
);

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function initRangePicker() {
  if (!dateRangeInput.value) return;

  const start = moment(filters.from, "YYYY-MM-DD");
  const end = moment(filters.to, "YYYY-MM-DD");

  const onPick = (s, e) => {
    filters.from = moment(s).format("YYYY-MM-DD");
    filters.to = moment(e).format("YYYY-MM-DD");
    filters.page = 1;
    rangeLabel.value = `${moment(s).format("DD MMM YYYY")} - ${moment(e).format(
      "DD MMM YYYY"
    )}`;
    fetchReport();
  };

  new DateRangePicker(
    dateRangeInput.value,
    {
      startDate: start,
      endDate: end,
      showDropdowns: true,
      autoApply: true,
      ranges: {
        Today: [moment(), moment()],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      },
    },
    onPick
  );
}

async function fetchReport() {
  await store.fetchAttendanceReport({
    from: filters.from,
    to: filters.to,
    status: filters.status || undefined,
    page: filters.page,
    per_page: filters.per_page,
  });
}

function onTableChange(pagination) {
  filters.page = pagination.current;
  filters.per_page = pagination.pageSize;
  fetchReport();
}

function setStatusFilter(status) {
  filters.status = status;
  filters.page = 1;
  fetchReport();
}

function setYear(year) {
  const start = moment(`${year}-01-01`, "YYYY-MM-DD");
  const end = moment(`${year}-12-31`, "YYYY-MM-DD");

  filters.from = start.format("YYYY-MM-DD");
  filters.to = end.format("YYYY-MM-DD");
  filters.page = 1;

  yearLabel.value = String(year);
  rangeLabel.value = String(year);

  // update the visible text in the date range input as well
  if (dateRangeInput.value) {
    dateRangeInput.value.value = `${start.format("DD/MM/YYYY")} - ${end.format(
      "DD/MM/YYYY"
    )}`;
  }

  fetchReport();
}

function setQuickRange(key) {
  let start, end, label;
  if (key === "last7") {
    start = moment().subtract(6, "days");
    end = moment();
    label = "Last 7 Days";
  } else if (key === "last30") {
    start = moment().subtract(29, "days");
    end = moment();
    label = "Last 30 Days";
  } else if (key === "thisMonth") {
    start = moment().startOf("month");
    end = moment().endOf("month");
    label = "This Month";
  } else if (key === "lastMonth") {
    start = moment().subtract(1, "month").startOf("month");
    end = moment().subtract(1, "month").endOf("month");
    label = "Last Month";
  } else {
    start = moment().subtract(6, "days");
    end = moment();
    label = "Last 7 Days";
  }

  filters.from = start.format("YYYY-MM-DD");
  filters.to = end.format("YYYY-MM-DD");
  filters.page = 1;
  rangeLabel.value = label;
  fetchReport();
}

function exportPdf() {
  store.exportAttendancePDF({
    from: filters.from,
    to: filters.to,
    status: filters.status || undefined,
  });
}

function exportExcel() {
  // Excel-style → CSV export
  store.exportAttendanceCSV({
    from: filters.from,
    to: filters.to,
    status: filters.status || undefined,
  });
}

// Summary cards
const summary = computed(() => store.attendanceSummary || {});
// const kpiCards = computed(() => [
//   {
//     title: "Total Working Days",
//     value: summary.value?.total_work_days || 0,
//     iconCls: "ti ti-calendar",
//     cls: "primary",
//   },
//   {
//     title: "Total Leave Taken",
//     value: summary.value?.total_leave || 0,
//     iconCls: "ti ti-calendar",
//     cls: "info",
//   },
//   {
//     title: "Total Holidays",
//     value: summary.value?.total_holidays || 0,
//     iconCls: "ti ti-calendar",
//     cls: "pink",
//   },
//   {
//     title: "Total Halfdays",
//     value: summary.value?.total_halfdays || 0,
//     iconCls: "ti ti-calendar",
//     cls: "warning",
//   },
// ]);

// Apex chart config
// const attendanceChart = computed(() => {
//   const items = store.attendanceSeries || [];
//   const labels = items.map((i) => i.label);

//   return {
//     options: {
//       chart: { type: "line", height: 200, toolbar: { show: false } },
//       stroke: { width: 2, curve: "smooth" },
//       dataLabels: { enabled: false },
//       xaxis: { categories: labels },
//       yaxis: {
//         labels: {
//           formatter: (v) => Number(v || 0).toFixed(0),
//         },
//         title: { text: "Days" },
//       },
//       tooltip: {
//         y: {
//           formatter: (v) => `${Number(v || 0).toFixed(0)} day(s)`,
//         },
//       },
//       legend: { position: "top" },
//     },
//     series: [
//       {
//         name: "Present",
//         data: items.map((i) => i.present || 0),
//       },
//       {
//         name: "Absent",
//         data: items.map((i) => i.absent || 0),
//       },
//       //   {
//       //     name: "Leave",
//       //     data: items.map((i) => i.leave || 0),
//       //   },
//       //   {
//       //     name: "Holiday",
//       //     data: items.map((i) => i.holiday || 0),
//       //   },
//     ],
//   };
// });

const attendanceChart = computed(() => {
  const items = store.attendanceSeries || [];
  const labels = items.map((i) => i.label);

  return {
    options: {
      chart: {
        type: "line",
        height: 200,
        toolbar: { show: false },
        parentHeightOffset: 0, // avoid extra cropping
      },
      stroke: { width: 2, curve: "smooth" },
      dataLabels: { enabled: false },
      grid: {
        padding: {
          left: 8, // give the y-axis title some breathing room
          right: 8,
        },
      },
      xaxis: { categories: labels },
      yaxis: {
        labels: {
          formatter: (v) => Number(v || 0).toFixed(0),
          style: {
            fontSize: "11px",
          },
        },
        title: {
          text: "Days",
          style: {
            fontSize: "11px",
            fontWeight: 600,
            color: "#555",
          },
          offsetX: 10, // move the text slightly into the chart so it's visible
          offsetY: 0,
        },
      },
      tooltip: {
        y: {
          formatter: (v) => `${Number(v || 0).toFixed(0)} day(s)`,
        },
      },
      legend: { position: "top" },
    },
    series: [
      {
        name: "Present",
        data: items.map((i) => i.present || 0),
      },
      {
        name: "Absent",
        data: items.map((i) => i.absent || 0),
      },
      // more series later if you want...
    ],
  };
});

onMounted(() => {
  initRangePicker();
  fetchReport();
});
</script>

<style scoped>
@media (max-width: 767.98px) {
  .dq-list-toolbar {
    align-items: stretch !important;
  }

  .dq-list-toolbar > * {
    width: 100%;
    margin-right: 0 !important;
  }

  .dq-list-toolbar .dropdown,
  .dq-list-toolbar .dropdown-toggle,
  .dq-list-toolbar .form-control {
    width: 100%;
  }

  .custom-datatable-filter.table-responsive {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
  }
}
</style>

<style scoped>
/* Add this style to center the attendance-report card body */
.card-attendance {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>


